import styled, { css } from 'styled-components';
import statusMapIcon_gas_blue from 'static/images/icon/statusMapIcon_gas_blue.png';

export const DispensingSimplePopupContainer = styled.div`
  width: 1255px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DispensingSimple = styled.div`
  width: 1255px;
  height: 700px;
  margin-right: 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 15px;
  text-align: center;
  background: rgb(39, 47, 60);
  border-radius: 8px;

  & > div.popup-cover {
    position: fixed;
    z-index: 999;
    width: 1255px;
    height: 710px;
    top: 0px;
    left: 0px;
    background: rgb(39 47 60 / 0%);
    display: none;
  }

  & > div.modules-container {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 10px 0px 30px 0px;

    & > div.module-box {
      flex: 1;
      height: 30px;
      background: #0c101f;
      margin: 0px 5px;
      font-size: 20px;
      cursor: pointer;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      &:hover {
        background: #e4e4e4;
        color: #0c101f;
      }

      & > div {
        flex: 4;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    & > div.on {
      background: #e4e4e4;
      color: #0c101f;
      font-weight: bold;
    }
  }
`;

export const DispensingSimpleSelectMap = styled.div`
  background: rgb(39, 47, 60);
  position: relative;
  width: 862px;
  height: 535px;
  display: flex;
  justify-content: center;
  align-items: center;

  & > img {
    width: 862px;
    height: 535px;
  }

  & > div.loading-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & > span {
      font-size: 35px;
    }
  }
`;

export const MapIconContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${(props) =>
    css`
      left: ${props.xAxis - 25}px;
      top: ${props.yAxis - 30}px;
    `}

  & > div {
    background: #0c101f;
    padding: 3px;
  }

  & > img {
    width: 50px;
    height: 50px;
    content: url(${statusMapIcon_gas_blue});
  }
`;
